<div class="tabs-container">
  <tpm-tabs [tabs]="tabs" [active]="tab()" (activeTabChange)="tab.set($event)"></tpm-tabs>
  <tpm-tabs
    *ngIf="!!childTabs().length"
    class="child-tabs"
    [child]="true"
    [tabs]="childTabs()"
    [active]="childTab()"
    (activeTabChange)="childTab.set($event)"
  ></tpm-tabs>
</div>
<ng-container [ngSwitch]="tab()">
  <ng-container *ngSwitchCase="'concession'">
    <ng-container [ngSwitch]="childTab()">
      <ng-container *ngSwitchCase="'modules'">
        <app-modules-tab></app-modules-tab>
      </ng-container>
      <ng-container *ngSwitchCase="'incident-management'">
        <ca-notification-settings [module]="'incident-management'"></ca-notification-settings>
      </ng-container>
      <ng-container *ngSwitchCase="'three-year-plan'">
        <ca-notification-settings [module]="'three-year-plan'"></ca-notification-settings>
      </ng-container>
      <ng-container *ngSwitchCase="'accounting'">
        <ca-notification-settings [module]="'accounting'"></ca-notification-settings>
      </ng-container>
      <ng-container *ngSwitchCase="'street-lighting'">
        <ca-notification-settings [module]="'street-lighting'"></ca-notification-settings>
      </ng-container>
      <ng-container *ngSwitchCase="'kwp'">
        <ca-notification-settings [module]="'kwp'"></ca-notification-settings>
      </ng-container>
      <ng-container *ngSwitchCase="'grid-connections'">
        <ca-notification-settings [module]="'grid-connections'"></ca-notification-settings>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'logs'">
    <nb-configuration-area-downloads logType="logs"></nb-configuration-area-downloads>
  </ng-container>
  <ng-container *ngSwitchCase="'reports'">
    <nb-configuration-area-downloads logType="reports"></nb-configuration-area-downloads>
  </ng-container>
</ng-container>
